import { useQuery } from '@lojinha/palantir'
import { useLojinhaContext } from '@lojinha/context'
import { PurchaseType } from '../type'
import { GET_MY_PURCHASES } from './queries'

export const useMyPurchases = () => {
  const { isAuthenticated } = useLojinhaContext()

  const { data, loading } = useQuery(GET_MY_PURCHASES, {
    skip: !isAuthenticated,
  })

  const purchases: PurchaseType[] = data?.viewer?.user?.sales?.nodes ?? []

  return { loading, purchases }
}
